import Vue from 'vue'
import App from '@/App'
import SmpHair from '@/components/Hair'
import { preposFixStr } from '@/utils/preposfix'

Vue.component('SmpHair', SmpHair)
Vue.filter('preposFix', preposFixStr)

new Vue({
  el: '#app',
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/index.js